/* @flow */

export type $State = {
  initial: string,
  current: string
};

export const SET_INITIAL_VIEW_MODE = 'dsw/view/SET_INITIAL_VIEW_MODE';
export const SET_CURRENT_VIEW_MODE = 'dsw/view/SET_CURRENT_VIEW_MODE';

const initialState: $State = {
  initial: '',
  current: ''
};

export const setInitialViewMode = (viewMode: string) => ({
  type: SET_INITIAL_VIEW_MODE,
  initial: viewMode
});

export const setCurrentViewMode = (viewMode: string) => ({
  type: SET_CURRENT_VIEW_MODE,
  current: viewMode
});

export default function reducer(state: $State = initialState, action: Object): $State {
  switch (action.type) {

    case SET_INITIAL_VIEW_MODE:
      return {
        initial: action.initial,
        current: ''
      };

    case SET_CURRENT_VIEW_MODE:
      return {
        ...state,
        current: action.current
      };

    default:
      return state;

  }
}
